<div
  class="slide mx-auto w-full h-full absolute top-0 left-0 animate-menu-appear"
  [hidden]="!active">
  <ng-content></ng-content>
</div>
